import React from "react"
import {Col, Row} from "react-bootstrap"
import HeadingSkeleton from "../../../components/skeletons/HeadingSkeleton";
import InputFieldSkeleton from "../../../components/skeletons/InputFieldSkeleton";

export default function Journals() {

    return(
        <div className={'journals'}>
            <Row>
                <Col md={12} lg={12} xl={8}>
                    <div className={'type'}>
                        <h4> <HeadingSkeleton height={10} maxWidth={200} block={true}/></h4>
                        <div className={'d-flex align-items-center gap-3'}>
                            <HeadingSkeleton height={70} block={true}/>
                            <HeadingSkeleton height={70} block={true}/>
                            <HeadingSkeleton height={70} block={true}/>
                        </div>
                    </div>
                    <div>
                        <div className={'create-events'}>

                            <Row>
                                <Col md={12}>
                                    {
                                        [1,2,3,4,5,6,7,8].map((item,index)=>{
                                            return(
                                                <InputFieldSkeleton key={index} labelWidth={400}/>
                                            )
                                        })
                                    }
                                </Col>
                            </Row>

                            <Row>
                                <Col md={12}>
                                    <div className={''}>
                                        <p className={'form-mess'}> <HeadingSkeleton height={10} maxWidth={700}/></p>
                                    </div>
                                    <div className={'d-flex flex-column mt-4'}>
                                        <HeadingSkeleton height={60} />
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Col>
                <Col className={'mt-4 mt-xl-0'} md={12} lg={12} xl={4}>
                    <div className={'journal-section'}>
                        <h4> <HeadingSkeleton maxWidth={100} height={10}/>
                            <span>
                                <HeadingSkeleton maxWidth={70} height={30}/>
                            </span>
                        </h4>
                        {
                            [1,2,3,4,5,6,7,8,9,10].map((item, index)=>{
                                return(
                                    <div className={'journal-card'} >
                                        <div className={'content'}>
                                            <p>   <HeadingSkeleton maxWidth={400} height={15}/></p>
                                            <span>
                                                <HeadingSkeleton maxWidth={40} height={10}/>
                                            </span>
                                        </div>
                                        <h5>  <HeadingSkeleton maxWidth={100} height={10}/><span>    <HeadingSkeleton maxWidth={80} height={10}/></span></h5>

                                    </div>
                                )
                            })
                        }

                    </div>

                </Col>
            </Row>


        </div>
    )
}